export function useDefaultPaymentMethods() {
  const state = {
    formattedCards: [],
    defaultPaymentMethods: [
      { type: 'businessAccount', title: 'account', brand: 'business', defaultPayment: false },
      { type: 'cash', title: 'cash', brand: 'cash', defaultPayment: false },
    ],
  };

  function generateCardsList(cards = []) {
    const params = state.defaultPaymentMethods.map((el) => ({
      type: el.type,
      brand: el.title,
      expiration: '',
      cardHolderName: '',
      staus: null,
      defaultPayment: false,
    }));

    const mappedCards = cards.map((el) => ({ ...el, type: 'creditCard', defaultPayment: false }));

    return [...params, ...mappedCards];
  }

  function setDefaultPayment(item, cardsList) {
    // reset all defaultPayments
    state.formattedCards = cardsList.map((el) => {
      // eslint-disable-next-line no-param-reassign
      el.defaultPayment = false;
      return el;
    });
    // set defaulyPayment in cardsList by item id if there is no id by type
    state.formattedCards = state.formattedCards.map((el) => {
      if (item.id && el.id && item.id === el.id) {
        // eslint-disable-next-line no-param-reassign
        el.defaultPayment = true;
        return el;
      }

      if (!item.id) {
        if (el.type === item.type) {
          // eslint-disable-next-line no-param-reassign
          el.defaultPayment = true;
          return el;
        }
      }

      return el;
    });

    return state.formattedCards;
  }

  function removeDefaultPayment() {
    localStorage.removeItem('defaultPayment');
  }

  return {
    formattedCards: state.formattedCards,
    setDefaultPayment,
    removeDefaultPayment,
    generateCardsList,
  };
}
